import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  OnInit,
} from '@angular/core';
import {
  GradeLevel,
  GradeLevelMap,
} from '@app/infrastructure/models/grade-level';

import {
  StudentGradeUnitListItemDTO,
  IStudentGradeUnitListItemDTO,
} from '@models/grade-unit/student-grade-unit';
import { StatusEnum } from '@models/status';

@Component({
  selector: 'app-student-grade-unit-presentation',
  templateUrl: './student-grade-unit-presentation.component.html',
  styleUrls: ['./student-grade-unit-presentation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StudentGradeUnitPresentationComponent implements OnInit {
  @Input() public gradeUnit: IStudentGradeUnitListItemDTO =
    new StudentGradeUnitListItemDTO();
  @Input() public scorePreview: boolean = false;
  @Output() public emitNavigateToAssignedUnitDays: EventEmitter<number> =
    new EventEmitter();

  public statusEnum = StatusEnum;
  public gradeText: string;

  // TODO: We need a score system
  public studentScore: number = 10;
  public unitTotalScore: number = 50;
  public unitAssignmentsCompleted: number = 2;
  public unitAssignmentsTotal: number = 5;

  public get hasOverdueAssignments(): boolean {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return this.gradeUnit.assignments.some(
      (assignment) => new Date(assignment.dueDate) < today,
    );
  }

  ngOnInit(): void {
    this.gradeText = `Grade: ${GradeLevelMap.mapGradeLevelEnumToRoute(
      this.gradeUnit.unitGradeLevel,
    )?.toString()}`;
  }

  public checkStatus(status: StatusEnum): {
    assigned: boolean;
    unassigned: boolean;
    inprogress: boolean;
    completed: boolean;
  } {
    return {
      assigned: status === StatusEnum.ASSIGNED,
      unassigned: status === StatusEnum.UNASSIGNED,
      inprogress: status === StatusEnum.INPROGRESS,
      completed: status === StatusEnum.COMPLETED,
    };
  }

  public getAltText(unitNumber: number): string {
    return `Unit ${unitNumber} Cover Photo`;
  }

  public navigate(unitNumber: number): void {
    this.emitNavigateToAssignedUnitDays.emit(unitNumber);
  }

  getStyles() {
    // Force status to ready for the time being since we don't actually show the status text, but want to keep the Unit title and styling
    const status = 'ready';
    let back: string = '';
    let fore: string = '';

    if (status === 'ready') {
      back = '#e8f4d4';
      fore = '#537917';
    } else if (status === 'in-progress') {
      back = '#ffeab0';
      fore = '#665117';
    }

    const myStyles = {
      backgroundColor: back,
      color: fore,
    };
    return myStyles;
  }
}
